import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  getFullName,
  getInitials,
  smartJoin,
} from "../../../../../util/helpers";
import PatientLoader from "../../../../common/PatientLoader";
import RiskPill from "../../../../common/RiskPill";
import Pdf from "react-to-pdf";
import { PatientNotesPDFComponent } from "./PatientNotes";
import { SingleNoteView } from "./NotesModal";
const PatientNotesPDF = (props) => {
  const [localLoading, setLocalLoading] = useState(true);
  const [isCompleted, setCompleted] = useState(false);
  const [managedBy, setManagedBy] = useState("");
  const pdfTarget = useRef();
  const downloadBtn = useRef();
  const { user } = useSelector((state) => state.app);
  const { loading, singlePatientData } = useSelector((state) => state.patient);
  const { bhiLoading, bhiData } = useSelector((state) => state.bhi);
  const [patientName, setPatientName] = useState(
    `${singlePatientData?.first_name} ${singlePatientData?.last_name}`
  );
  const pdfOptions = {
    orientation: "portrait",
    unit: "in",
    format: [30, 15],
  };

  const getManagedBy = () => {
    try {
      const allManagers = [
        user?.id,
        ...singlePatientData?.shared_with_clinical_staff,
      ];
      let sharedManagers = staffData
        .filter((staff) => {
          if (allManagers.includes(staff.id)) {
            return staff;
          }
        })
        .map((staff) => {
          return getFullName(staff);
        });

      sharedManagers = smartJoin(sharedManagers);
      return sharedManagers;
    } catch (e) {
      return getFullName(user);
    }
  };

  useEffect(() => {
    if (user) {
      const tempManagedBy = getManagedBy();
      setManagedBy(tempManagedBy);
    }
  }, []);

  useEffect(() => {
    if (!loading && !bhiLoading) {
      setLocalLoading(false);
    } else {
      setLocalLoading(true);
    }
  }, [loading, bhiLoading]);

  useEffect(() => {
    if (!localLoading) {
      downloadBtn.current.click();
      setTimeout(() => {
        props?.setNotesDownloadMode(false);
        props?.singleNote && props?.setSingleNote(false);
        window.clearTimeout();
      }, 2500);
    }
  }, [localLoading]);

  return (
    <>
      {localLoading ? (
        <PatientLoader />
      ) : (
        <section
          ref={pdfTarget}
          className="container-fluid w-100 p-5 bg-white"
          style={{
            margin: "0px",
            padding: "0px",
          }}
        >
          <Pdf
            targetRef={pdfTarget}
            filename={`${moment(new Date()).format(
              "MM-DD-YYYY--HH_mm_ss"
            )}-${patientName}`}
            options={pdfOptions}
            onComplete={() => {
              setCompleted(true);
              props?.setNotesDownloadMode(false);
            }}
          >
            {({ toPdf }) => (
              <button
                ref={downloadBtn}
                onClick={() => {
                  if (!isCompleted) {
                    toPdf();
                  }
                }}
                className="primary-btn"
                hidden={true}
              >
                Download
              </button>
            )}
          </Pdf>

          <div className="d-flex justify-content-between my-3">
            <h3>Patient Notes</h3>
            <span style={{ display: "flex", gap: "10px" }}>
              <strong className="muted-text">Download Date:</strong>{" "}
              {moment(new Date()).format("MM/DD/yyyy")}
            </span>
          </div>

          <div className="container-fluid p-3 row my-2">
            <div className="col-sm-12 col-md-3 col-lg-3">
              <div>
                <img
                  height="125px"
                  width="125px"
                  alt="User's DP"
                  style={{ borderRadius: "100%", padding: "0.2rem" }}
                  src={`https://placehold.co/125x125/f1f1f5/395E9D/?text=${getInitials(
                    patientName
                  )}`}
                />
                <RiskPill
                  styles={{ width: "40%" }}
                  type={singlePatientData?.flag}
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-3 col-lg-3">
              <div className="my-2">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  First name
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {singlePatientData?.first_name}
                </label>
              </div>
              <div className="my-2">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  Email
                </small>
                <label className="primary-text">
                  {singlePatientData?.email}
                </label>
              </div>
              <div className="my-2">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  BHI Status
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {singlePatientData?.bhi_enabled ? "Enabled" : "Disabled"}
                </label>
              </div>
              <div className="my-2">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  Managed By
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {managedBy}
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-md-3 col-lg-3">
              <div className="my-1">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  Last name
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {singlePatientData?.last_name}
                </label>
              </div>

              <div className="my-1">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  Date Of Birth
                </small>
                <label className="primary-text">
                  {singlePatientData?.date_of_birth
                    ? `${moment(props?.date_of_birth).format(
                        "MM - DD - YYYY"
                      )} (${moment().diff(
                        props?.date_of_birth,
                        "years"
                      )} yrs old)`
                    : "Unavailable"}
                </label>
              </div>
              <div className="my-1">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  BHI Diagnosis
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize", textAlign: "start" }}
                >
                  {bhiData?.diagnosis || "Unavailable"}
                </label>
              </div>
              <div className="my-1">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  Chat Status
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {props?.rose_chat ? "Enabled" : "Disabled"}
                </label>
              </div>
            </div>
          </div>
          <div className="d-flex container-fluid p-3 my-2">
            <span className="muted-text">Date Range:-</span>
            <strong>
              {moment(props?.startDate).format("MM/DD/YYYY")} -{" "}
              {moment(props?.endDate).format("MM/DD/YYYY")}
            </strong>
          </div>

          <div className="container-fluid p-3 my-2">
            {props?.singleNote ? (
              <SingleNoteView title="View Note" data={props?.singleNoteData} />
            ) : (
              <>
                <div className="d-flex mb-2">
                  <label style={{ fontSize: "1.3rem" }}>
                    All Patient Notes
                  </label>
                </div>
                <PatientNotesPDFComponent showTitle={false} />
              </>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default PatientNotesPDF;
